import {
  Component,
  ComponentFactoryResolver, ComponentRef,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  ViewChild
} from "@angular/core";
import {Subject} from "rxjs";
import {Cneh} from "../../../../model/cneh.model";
import {IFieldConfig, ListerComponent} from "../../../generics/lister/lister.component";
import {DynamicHostDirective} from "../../../../directives/dynamic-host.directive";
import {ListGetterService} from "../../../../services/generic/list-getter.service";
import {SpecialityService} from "../../../../services/speciality.service";

@Component({
  selector: 'app-list-speciality',
  templateUrl: './list-speciality.component.html',
  styleUrls: ['./list-speciality.component.scss']
})
export class ListSpecialityComponent implements OnInit {

  @Input()
  hookEvents: Subject<string>;

  @Input()
  actions: String[];

  // =============================== OUTPUTS
  @Output()
  select: EventEmitter<Cneh> = new EventEmitter();

  @Output()
  delete: EventEmitter<Cneh> = new EventEmitter();

  @Output()
  create: EventEmitter<Cneh> = new EventEmitter();

  component: any;
  fields: IFieldConfig[] = [
    {
      key: "title",
      i18Key: "speciality.title",
      width: 35,
      searchable: true
    },
    {
      key: "description",
      i18Key: "speciality.description",
      width: 65,
      searchable: true
    },
  ];

  @ViewChild(DynamicHostDirective, {static: true}) dynamicHost: DynamicHostDirective;

  constructor(private factory: ComponentFactoryResolver,
              private specialityService: SpecialityService,
              private injector: Injector
  ) {
    this.component = ListerComponent
  }

  ngOnInit(): void {
    let factory = this.factory.resolveComponentFactory(this.component);
    const ref: ComponentRef<any> = this.dynamicHost.viewContainerRef.createComponent(factory, undefined, Injector.create({
      providers: [
        {
          provide: ListGetterService,
          useValue: this.specialityService
        },
        {
          provide: "FIELD_CONFIG",
          useValue: this.fields
        }
      ],
      parent: this.injector
    }));
    ref.instance.queriables = ['constraint.title'];
    ref.instance.actions = this.actions;
    ref.instance.select = this.select;
    ref.instance.delete = this.delete;
    ref.instance.create = this.create;
    ref.instance.hookEvents = this.hookEvents;
  }

}
